<template>
  <div>
    <div class="notify-left">
      <img src="https://assets.sororitywars.app/icons/notify/V2/slap.png" width="40" height="40" class="desktop-notify-image" />
    </div>
    <div class="notify-right">
      <button type="button" class="notify-close" aria-label="Dismiss notification" @click="$emit('closeMe')">&times;</button>
      <div class="notify-alert">Live alert</div>
      <div class="notify-title">
        You're Being Slapped by
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.offender.id } }">
          {{notif.entry.content.offender.name}}
        </router-link>!
      </div>
    </div>
    <router-link class="notify-image pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.offender.id } }">
      <img src="https://assets.sororitywars.app/icons/notify/V2/slap.png" width="40" height="40" class="notify-image" @click="$emit('closeMe')" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Slapped',
  props: {
    notif: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
